import React from 'react';
import PropTypes from 'prop-types';
import { useDemoContext } from '../contexts/DemoContext';
import { useNavigate } from 'react-router-dom';
import { IoPlayCircle } from 'react-icons/io5';
import '../stylesheets/components/DemoStartButton.css';

const DemoStartButton = ({ variant = 'primary', className = '' }) => {
  const { startDemo } = useDemoContext();
  const navigate = useNavigate();

  const handleStartDemo = () => {
    startDemo();
    navigate('/demo/conversations');
  };

  return (
    <button
      className={`demo-start-button demo-start-button--${variant} ${className}`}
      onClick={handleStartDemo}
    >
      <IoPlayCircle className="demo-start-button__icon" />
      <span className="demo-start-button__text">
        <strong>Try Demo</strong>
        <small>{variant === 'secondary' ? 'Experience Forward Together without real data' : 'See how Forward Together works without creating real data'}</small>
      </span>
    </button>
  );
};

DemoStartButton.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary']),
  className: PropTypes.string
};

export default DemoStartButton;
